import React from 'react';
import GoogleMapReact from 'google-map-react';

const Map = ({ center, zoom, markers }) => {
  const renderMarkers = (map, maps) => {
    markers && markers.forEach(({ lat, lng, name }) => {
      const marker = new maps.Marker({
        position: { lat, lng },
        map,
        title: name,
      });
    });
  };

  return (
    <div style={{ height: '400px', width: '100%' }}>
      <GoogleMapReact
        //bootstrapURLKeys={{ key: 'AIzaSyDGpJFs5U73UY_kzvs9qTZ0n6FObEZHRz0' }}
        bootstrapURLKeys={{ key: 'AIzaSyAHNsBw1S9mG_MHaNRtTreax_2qbRNmTm0' }}
        defaultCenter={center}
        defaultZoom={zoom}
        onGoogleApiLoaded={({ map, maps }) => renderMarkers(map, maps)}
      />
    </div>
  );
};

export default Map;
